(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('EditVerbsCtrl', ['$http', '$scope', '$timeout', 'Alerts', 'Api', 'Interactions', 'RequestCache', 'TinCanJS', 'Logger', 'Utils', '$rootScope', 'VerbResources', function ($http, $scope, $timeout, Alerts, Api, Interactions, RequestCache, TinCanJS, Logger, Utils, $rootScope, VerbResources) {
    $scope.saveEnabled = true;

    // Basically, event handler for change of selected verb from the
    // verb type-ahead directive.
    $scope.$watch("selectedEditVerb", function (newValue) {
      if (newValue) {
        $scope.success = null;
        $scope.selectedEditVerb = newValue;
        $scope.verbId = newValue.verbId;
        $scope.savedDisplay = newValue.display;
      }
    });
    $scope.updateDisplay = function updateDisplay(display) {
      $scope.isValidName = display.length > 0;
      $scope.saveEnabled = $scope.savedDisplay !== display && $scope.isValidName ? true : false;
      if ($scope.savedDisplay === display || !$scope.isValidName) {
        $scope.saveEnabled = false;
      } else {
        $scope.saveEnabled = true;
      }
      $scope.selectedEditVerb.display = display;
    };
    $scope.save = function save() {
      VerbResources.save($scope.selectedEditVerb.verbId, $scope.selectedEditVerb.display).then(function success(response) {
        $scope.successMessage = "A new alias for '" + response.data.display + "' has been created. " + "Please allow up to 30 minutes before this change is reflected in Watershed.";
        $scope.selectedEditVerb = response.data;
        $rootScope.$broadcast('verb-edited');
        $scope.recentVerbs.splice($scope.savedIndex, 1);
        $scope.recentVerbs = [$scope.selectedEditVerb].concat($scope.recentVerbs);
        clearVerb();
      }, function error(response) {
        if (response && response.data) {
          $scope.errorMessage = response.data.message;
        }
        clearVerb();
      });
    };
    $scope.cancel = function cancel() {
      clearVerb();
    };
    function clearVerb() {
      $scope.verbId = null;
      $scope.selectedEditVerb = null;
      $scope.clearVerbTypeAhead();
    }
    $scope.clearVerbTypeAhead = function clearVerbTypeahead() {
      Utils.setIn($scope, ['utils', 'verbs', 'typeaheadSelection'], '');
    };
    function loadRecentVerbs() {
      VerbResources.getRecent(5).then(function (response) {
        $scope.recentVerbs = _.reject(response.data.results, function (verb) {
          return !verb.updated;
        });
      }, function () {
        $scope.recentVerbs = [];
      });
    }
    $scope.editVerb = function editVerb(verbToEdit) {
      $scope.success = null;
      $scope.selectedEditVerb = verbToEdit;
      $scope.verbId = verbToEdit.verbId;
      $scope.display = verbToEdit.display;
      $scope.savedDisplay = verbToEdit.display;
      $scope.savedIndex = $scope.recentVerbs.indexOf(verbToEdit);
    };
    // Init by clearing editing state and loading recent Verb
    $scope.recentVerbs = [];
    loadRecentVerbs();
  }]);
})();
